const metadataSlice = {
    navButtons: {
        builder: true,
        preset: true
    }
}

export default metadataSlice
export { metadataSlice }



// WEBPACK FOOTER //
// ./src/app/configuration/Square/config/components/selection/MetadataSlice/index.js